import { inject, Injectable } from '@angular/core';
import { ModalService } from '../ui/modal/modal.service';
import { StartComponent } from './start.component';
import { EMPTY, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StartService {

  private modal = inject(ModalService)

  showModal() {
    return this.modal.create(StartComponent, {fullscreen: true, showClose: false}).pipe(
      switchMap(modal => modal?.events$ ?? EMPTY)
    )
  }

  destroyModal() {
    if (this.modal.activeModal) {
      this.modal.destroy(this.modal.activeModal)
    }
  }
}
